import { render, staticRenderFns } from "./CriarGrupo.vue?vue&type=template&id=5cf49098&"
import script from "./CriarGrupo.vue?vue&type=script&lang=ts&"
export * from "./CriarGrupo.vue?vue&type=script&lang=ts&"
import style0 from "./CriarGrupo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports